const PageCreateAccount = () => import('./PageCreateAccount');

export default {
  path: '/create-account',
  name: 'createAccount',
  component: PageCreateAccount,
  meta: {
    title: 'Criar conta',
  },
};



// WEBPACK FOOTER //
// ./src/features/public/login/create-account/routes.js